export default __webpack_public_path__ + "static/media/devguide06.924e5975.md";